import { FormHelperText, Link } from 'apollo-react';
import Button from 'apollo-react/components/Button';
import Card from 'apollo-react/components/Card';
import CardContent from 'apollo-react/components/CardContent';
import CardHeader from 'apollo-react/components/CardHeader';
import Container from 'apollo-react/components/Container';
import DatePicker from 'apollo-react/components/DatePicker';
import Grid from 'apollo-react/components/Grid';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import TextField from 'apollo-react/components/TextField';
import Typography from 'apollo-react/components/Typography';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import ConfirmDialog from '../common/ConfirmDialog';
import { API_URL, NO_SEND_FLG, OBJ_ROLE, PROMPTLY_FLG, STATUS_CODE, SYS_ROLE } from '../common/Constants';
import DetailDialog from '../common/DetailDialog';
import Dialog from '../common/Dialog';
import Loading from '../common/Loading';
import { checkFileName, getApi, getFuncroleFlg, getHeader, postApi, setMessage, setURL, toISOStringWithTimezone, redirectToLogin, MaintenanceApiError, CustomApiError } from '../common/Utils';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { Box } from '@mui/material';
import './AddUser.scss';
import selectItemUserRoleList from '../json/selectItemUserRoleList.json';
import selectItemOrgList from '../json/selectItemOrgList.json';
import selectItemGetIqviaCode from '../json/iqviaCode.json';
import Tooltip from '@mui/material/Tooltip';
import Autocomplete from '@mui/material/Autocomplete';
//メールサンプル表示
import IconButton from '@mui/material/IconButton';
import AttachEmailIcon from 'apollo-react-icons/EmailError';
/**
 * 納品アップロード_変更
 */
function AddUser() {
	const location = useLocation();
	const [t, i18n] = useTranslation();
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(true);
	const DIALOG_STATUS = {
		NO_DIALOG: '0',
		OK_DIALOG: '1',
		DETAIL_DIALOG: '2',
		ADDUSER_CONFIRM_DIALOG: '3',
		ADDUSER_COMPLETE_DIALOG: '4',
		OK_DIALOG_BACK: '5',
		DETAIL_DIALOG_BACK: '6',
	};

	// 確認ダイアログ表示用フラグ
	const [dialogStatus, setDialogStatus] = useState(DIALOG_STATUS.NO_DIALOG);
	const [dialogOpen, setDialogOpen] = useState(false);
	const [dialogContent, setDialogContent] = useState('');
	const [detailContent, setDetailContent] = useState('');
	const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
	const [confirmDialogContent, setConfirmDialogContent] = useState('');

	// 各種権限
	const [flgUserid, setFlgUserid] = useState(false);
	const [flgUserNameJp, setFlgUserNameJp] = useState(false);
	const [flgUserNameEn, setFlgUserNameEn] = useState(false);
	const [flgOrgSelector, setFlgOrgSelector] = useState(false);
	const [flgOrg1Selector, setFlgOrg1Selector] = useState(false);
	const [flgMailAddress, setFlgMailAddress] = useState(false);
	const [flgExpiryDate, setFlgExpiryDate] = useState(false);

	// ユーザー登録情報の入力内容
	const [formValues, setFormValues] = useState({
		userId: '',
		userNameJp: '',
		userNameEn: '',
		company: '',
		companyName: '',
		department: '',
		departmentName: '',
		email: '',
		usrroleCode: '',
		expiryDate: "2999/12/31"
	});
	// ユーザー保存フラグ
	const [addUserSaveBtnAuthFlg, setAddUserSaveBtnAuthFlg] = useState(false);
	// 企業名の選択リスト
	const [compList, setCompList] = useState([]);
	// 権限の選択リスト
	const [userRoleList, setUserRoleList] = useState([]);

	/**
	 * 共通エラー処理
	 * @param {object} error エラーオブジェクト
	 * @param {string} detailErrorMessage 詳細ダイアログに設定するエラーメッセージ
	 */
	const commonError = (error, detailErrorMessage) => {
		if (error.name === 'MaintenanceApiError') {
			navigate('/', { state: { maintenanceFlg: true, } });
		} else if (error.name === 'CustomApiError') {
			const message = error.message;
			setDialogStatus(DIALOG_STATUS.OK_DIALOG);
			setDialogOpen(true);
			setDialogContent(message);
		} else {
			setDialogStatus(DIALOG_STATUS.DETAIL_DIALOG);
			setDialogOpen(true);
			setDialogContent(detailErrorMessage);
			setDetailContent(error.stack);
		}
	};

	/**
	 * ユーザー追加ボタン押下時の処理
	 */
	const handleAddUserBtnClick = () => {

		const atIndex = formValues.email.indexOf('@');
		const domain = formValues.email.slice(atIndex + 1);

		const validDomains = {
			"mail1": "iqvia.com",
			"mail2": "ims.health.com",
			"mail3": "quintiles.com"
		};

		if (formValues.company === iqviaOrgCode && Object.values(validDomains).includes(domain) == false) {
			var message = t('message.1001740');
			setDialogStatus(DIALOG_STATUS.OK_DIALOG);
			setDialogOpen(true);
			setDialogContent(message)
		}
		else if (formValues.company !== iqviaOrgCode && Object.values(validDomains).includes(domain) == true) {
			var message = t('message.1001730');
			setDialogStatus(DIALOG_STATUS.OK_DIALOG);
			setDialogOpen(true);
			setDialogContent(message)
		}
		else {
			var message = "";
			message = t('message.1002100');
			setDialogStatus(DIALOG_STATUS.ADDUSER_CONFIRM_DIALOG);
			setConfirmDialogOpen(true);
			setConfirmDialogContent(message)
		}
	}

	/**
	 * ダイアログでOKボタン押下時の処理
	 */
	const onOk = () => {
		setDialogStatus(DIALOG_STATUS.NO_DIALOG);
		setDialogOpen(false);
		if (dialogStatus === DIALOG_STATUS.OK_DIALOG_BACK || dialogStatus === DIALOG_STATUS.DETAIL_DIALOG_BACK) {
			// ユーザー管理画面へ遷移
			navigate('/userManagement');
		}

		if (dialogStatus === DIALOG_STATUS.ADDUSER_COMPLETE_DIALOG) {
			// 完了時リロード
			window.location.reload();
		}
	};

	/**
	 * 確認ダイアログでキャンセルボタン押下時の処理
	 */
	const onCancel = () => {
		setDialogStatus(DIALOG_STATUS.NO_DIALOG);
		setConfirmDialogOpen(false);
	};

	/**
	 * キャンセルボタン押下時の処理
	 */
	const handleCancelClick = () => {
		commonBack();
	}

	/**
	 * 共通ユーザー管理画面遷移処理
	 */
	const commonBack = () => {
		// ユーザー管理画面へ遷移
		navigate('/userManagement');
	};

	/**
	 * ユーザー追加APIの成功時の処理
	 */
	function addUserSuccess() {
		setDialogStatus(DIALOG_STATUS.ADDUSER_COMPLETE_DIALOG);
		const message = t('message.1002200');
		setDialogOpen(true);
		setDialogContent(message);
	};

	/**
	 * アップロードAPIの失敗時の処理
	 * @param {object} error エラーオブジェクト
	 */
	function addUserError(error) {
		if (error.name === 'MaintenanceApiError') {
			navigate('/', { state: { maintenanceFlg: true, } });
		} else if (error.name === 'CustomApiError') {
			//入力テキストに禁則文字が含まれている場合、azureのインフラルールによりエラーとなる
			//ただし、エラーは403 Forbiddenとしか返って来ない（＝禁則文字によるエラーだと判別できない）ため、メッセージを変更する
			const forbidCharPat1 = /.+403 Forbidden.+/;
			const forbidCharPat2 = /.+Microsoft-Azure-Application-Gateway.+/;
			if ((error.message.match(forbidCharPat1)) && (error.message.match(forbidCharPat2))) {
				const message = t('message.1000810');
				setDialogStatus(DIALOG_STATUS.OK_DIALOG);
				setDialogOpen(true);
				setDialogContent(message);

				//認証期限切れの場合は再ログイン
				redirectToLogin();
			} else {
				const message = error.message;
				setDialogStatus(DIALOG_STATUS.DETAIL_DIALOG);
				setDialogOpen(true);
				setDialogContent(message);
				setDetailContent(error.stack);

				//認証期限切れの場合は再ログイン
				redirectToLogin();
			}
		} else {
			const message = error.message;
			setDialogStatus(DIALOG_STATUS.DETAIL_DIALOG);
			setDialogOpen(true);
			setDialogContent(message);
			setDetailContent(error.stack);

			//認証期限切れの場合は再ログイン
			redirectToLogin();
		}

		//認証期限切れの場合は再ログイン
		redirectToLogin();
	};

	/**
	 * ユーザー追加時の確認ダイアログでOKボタン押下時の処理
	 */
	const onAddUserConfirmOK = async () => {
		// setConfirmDialogOpen(false);
		// アップロードAPI
		const url = setURL(API_URL.USER_UPSERT);
		let formData = new FormData();
		formData.append('forInsert', true);
		formData.append('userid', formValues.userId);
		formData.append('userName', formValues.userNameJp);
		formData.append('userEng', formValues.userNameEn);
		formData.append('orgLevel0Code', formValues.company);
		formData.append('companyName', formValues.companyName);
		// formData.append('orgLevel1Code', formValues.department);
		formData.append('departmentName', formValues.departmentName);
		formData.append('email', formValues.email);
		formData.append('usrroleCode', formValues.usrroleCode);

		// 部署登録フォームでの登録対策のため再度入れ込み
		const matchedDept = filteredOrgLevel1Infos.find(dept => dept.dept === formValues.departmentName);
		if (matchedDept) {
			formData.append('orgLevel1Code', matchedDept.orgLevel1Code);
		} else {
			formData.append('orgLevel1Code', "");
		}

		// const expiryDateConvert = new Date(formValues.expiryDate);
		// const option = {year: 'numeric', month: '2-digit', day: '2-digit'};
		// formData.append('expiryDate', expiryDateConvert.toLocaleDateString('ja-JP', option).split("/").join("-"));

		const expiryDateConvert = new Date(formValues.expiryDate);
		const option = { year: 'numeric', month: '2-digit', day: '2-digit' };
		const formattedExpiryDate = expiryDateConvert.toLocaleDateString('ja-JP', option).split("/").join("-");
		formData.append('expiryDate', formattedExpiryDate);

		const emailData = JSON.parse(localStorage.getItem('email'));
		const sessionUserEmail = emailData.email;
		formData.append('sessionUserEmail', sessionUserEmail);

		const postApiParam = {
			url: url,
			sysRole: SYS_ROLE.ADD_USER,
			body: formData,
			success: addUserSuccess,
			error: addUserError,
		};
		postApi(postApiParam);
	};

	/**
	 * 企業情報取得APIの成功時の処理
	 * @param {array} response 企業情報取得APIのレスポンス
	 */
	function complistApiSuccess(response) {
		// サービス名選択リストをセット
		setCompList(response);
	};

	/**
	 * 企業情報取得APIの失敗時の処理
	 * @param {object} error エラーオブジェクト
	 */
	function complistApiError(error) {
		const detailErrorMessage = '企業情報取得処理でエラーが発生しました。\n(An error occurred during the getorglist process.)';
		commonError(error, detailErrorMessage);

		//認証期限切れの場合は再ログイン
		redirectToLogin();
	};

	/**
	 * 権限情報取得APIの成功時の処理
	 * @param {array} response 部署情報取得APIのレスポンス
	 */
	function roleListApiSuccess(response) {
		// 部署名選択リストをセット
		setUserRoleList(response);
	};

	/**
	 * 権限情報取得APIの失敗時の処理
	 * @param {object} error エラーオブジェクト
	 */
	function roleListApiError(error) {
		const detailErrorMessage = '権限情報取得処理でエラーが発生しました。\n(An error occurred during the getrolelist process.)';
		commonError(error, detailErrorMessage);

		//認証期限切れの場合は再ログイン
		redirectToLogin();
	};

	/**
	 * IQVIAコード取得API成功処理
	 * @param {array} response
	 */
	function getIqviaCodeApiSuccess(response) {
		setIqviaOrgCode(response.iqviaOrgCode);
	};

	/**
	 * IQVIAコード取得APIの失敗時の処理
	 * @param {object} error
	 */
	function getIqviaCodeApiError(error) {
		const detailErrorMessage = '組織コード情報取得処理でエラーが発生しました。\n(An error occurred during the getorginfo process.)';
		commonError(error, detailErrorMessage);

		//認証期限切れの場合は再ログイン
		redirectToLogin();
	};

	// 各項目バリデーション
	const [usrVali, setUsrVali] = useState(false);
	const [nameJpVali, setNameJpVali] = useState(false);
	const [nameEnVali, setNameEnVali] = useState(false);
	const [org0Vali, setOrg0Vali] = useState(false);
	const [org1Vali, setOrg1Vali] = useState(false);
	const [emailVali, setEmailVali] = useState(false);
	const [roleVali, setRoleVali] = useState(false);

	// ユーザー名のバリデーション
	const validateUserid = (value) => {
		if (value.length > 50) {
			return format(t('message.1000300'), t('userId'), 50);
		}
		if (formValues.company != iqviaOrgCode && value === '') {
			return (
				<>
					{t('message.1001710')}
					<br />
					{t('message.1001711')}
				</>
			);
		}		
		if (value === '')
		{
			return t('message.1001715');
		}
		return '';
	};

	// 日本語名のバリデーション
	const validateUserNameJp = (value) => {
		if (value.length > 30) {
			return format(t('message.1000300'), t('userNameJp'), 30);
		}
		if (!value.includes(' ') && !value.includes('　')) {
			return t('message.1001700');
		}
		return '';
	};

	// 英語名のバリデーション
	const validateUserNameEng = (value) => {
		if (value.length > 60) {
			return format(t('message.1000300'), t('userNameEn'), 60);
		}
		if (!value.includes(' ')) {
			return t('message.1001800');
		}
		return '';
	};

	const validateMail = (value) => {
		if (value.length > 300) {
			return format(t('message.1000300'), t('email'), 300);
		}
		if (!value.includes('@')) {
			return (
				<>
					{t('message.1001900')}
					<br />
					{t('message.1001910')}
				</>
			);
		}
		if (formValues.userId != value && formValues.company != iqviaOrgCode && formValues.companyName != null) {
			return t('message.1001720')
		}
		return '';
	};

	// 会社選択のバリデーション
	const validateComp = (value) => {
		if (!value) {
			return format(t('message.1000205'), t('company'));
		}
		return '';
	};

	// 部署選択のバリデーション
	const validateDept = (value) => {
		if (!value) {
			return format(t('message.1000210'), t('department'));
		}
		return '';
	};

	// 権限選択のバリデーション
	const validateRole = (value) => {
		if (!value) {
			return format(t('message.1000206'), t('authority'));
		}
		return '';
	};

	// 有効期限のバリデーション
	const validateExpiryDate = (value) => {
		if (!value || formValues.expiryDate === '2999/12/31') {
			return t('message.1002000');
		}
		return '';
	};

	// C#のプレースホルダーをJavascriptで使用するための処理
	const format = (str, ...args) => {
		for (const [i, arg] of args.entries()) {
			const regExp = new RegExp(`\\{${i}\\}`, 'g')
			str = str.replace(regExp, arg)
		}
		return str
	}

	const [filteredOrgLevel1Infos, setFilteredOrgLevel1Infos] = useState([]);
	const [filteredUserRoleDescs, setFilteredUserRoleDescs] = useState([]);
	const [iqviaOrgCode,setIqviaOrgCode] = useState('');

	useEffect(() => {
		(async () => {
			if (window.localStorage.getItem(['token']) === null) {
				navigate('/')
				return;
			}

			// 権限系設定
			// ユーザー追加画面保存ボタン権限を設定
			setAddUserSaveBtnAuthFlg(getFuncroleFlg(SYS_ROLE.ADD_USER, OBJ_ROLE.SAVE_BTN));

			// ユーザーIDの権限フラグを設定
			const useridAuthFlg = getFuncroleFlg(SYS_ROLE.ADD_USER, OBJ_ROLE.USER_ID);
			setFlgUserid(useridAuthFlg);

			// ユーザー名JPの権限フラグを設定
			const userNameJpFlg = getFuncroleFlg(SYS_ROLE.ADD_USER, OBJ_ROLE.USER_NAME_JP);
			setFlgUserNameJp(userNameJpFlg);

			// ユーザー名ENの権限フラグを設定
			const userNameEnFlg = getFuncroleFlg(SYS_ROLE.ADD_USER, OBJ_ROLE.USER_NAME_EN);
			setFlgUserNameEn(userNameEnFlg);

			// 企業名選択の権限フラグを設定
			const orgselectorFlg = getFuncroleFlg(SYS_ROLE.ADD_USER, OBJ_ROLE.ORG_SELECTOR);
			setFlgOrgSelector(orgselectorFlg);

			// 部署名選択の権限フラグを設定
			const org1selectorFlg = getFuncroleFlg(SYS_ROLE.ADD_USER, OBJ_ROLE.ORG1_SELECTOR);
			setFlgOrg1Selector(org1selectorFlg);

			// メールアドレスの権限フラグを設定
			const mailAddressFlg = getFuncroleFlg(SYS_ROLE.ADD_USER, OBJ_ROLE.MAIL_ADDRESS);
			setFlgMailAddress(mailAddressFlg);

			// 有効期限の権限フラグを設定
			const expiryDateFlg = getFuncroleFlg(SYS_ROLE.ADD_USER, OBJ_ROLE.EXPIRY_DATE);
			setFlgExpiryDate(expiryDateFlg);

			// 会社・部署取得API
			const url = setURL(API_URL.SELECT_ITEM_ORGLIST);
			const getApiParam = {
				url: url,
				sysRole: SYS_ROLE.ADD_USER,
				success: complistApiSuccess,
				error: complistApiError,
				json: selectItemOrgList,
			}
			await getApi(getApiParam);

			// 権限取得API
			const roleurl = setURL(API_URL.SELECT_ITEM_USER_ROLE_LIST) + '?';
			// クエリパラメータ作成
			const params = {};
			params['showAdmin'] = false;
			const urlSearchParam =  String(new URLSearchParams(params));
			const getRoleApiParam = {
				url: roleurl + urlSearchParam,
				sysRole: SYS_ROLE.ADD_USER,
				success: roleListApiSuccess,
				error: roleListApiError,
				json: selectItemUserRoleList,
			}
			await getApi(getRoleApiParam);

			// orgcode取得
			const iqviacodeurl = setURL(API_URL.SELECT_ITEM_GET_IQVIACODE);
			const getIqviaCodeApiParam = {
				url: iqviacodeurl,
				sysRole: SYS_ROLE.ADD_USER,
				success: getIqviaCodeApiSuccess,
				error: getIqviaCodeApiError,
				json: selectItemGetIqviaCode,
			}
			await getApi(getIqviaCodeApiParam);

			setIsLoading(false);
		})();
	}, []);

	// 企業名を変更した際の処理
	useEffect(() => {
		const matchedComp = compList.find(comp => comp.comp === formValues.companyName);
		if (matchedComp) {
			formValues.company = matchedComp.orgLevel0Code;
		} else {
			formValues.company = "";
		}

		// 選択されたorgLevel0Codeに基づいてorgLevel1Infosをフィルタリング
		if (matchedComp != null) {
			const selectedComp = compList.find(comp => comp.orgLevel0Code === matchedComp.orgLevel0Code);
			setFilteredOrgLevel1Infos(selectedComp ? selectedComp.orgLevel1Infos : []);

			let filteredInfos = selectedComp ? selectedComp.orgLevel1Infos : [];

			//// 特定のorgLevel0Codeの場合、「利用者」を除外他は利用者のみ選択可能
			if (matchedComp.orgLevel0Code === iqviaOrgCode) {
				filteredInfos = userRoleList.filter(userRoleList => userRoleList.usrroleDesc !== t('client') && userRoleList.usrroleDesc !== t('limitedClient'));
			}
			else {
				filteredInfos = userRoleList.filter(userRoleList => userRoleList.usrroleDesc === t('client') || userRoleList.usrroleDesc === t('limitedClient'));
			}
			setFilteredUserRoleDescs(filteredInfos);
		}
		else{
			let filteredInfos = userRoleList.filter(userRoleList => userRoleList.usrroleDesc === t('client') || userRoleList.usrroleDesc === t('limitedClient'));
			setFilteredOrgLevel1Infos([]);
			setFilteredUserRoleDescs(filteredInfos);
		}

	}, [formValues.companyName]);

	// 部署名を変更した際の処理
	useEffect(() => {
		const matchedDept = filteredOrgLevel1Infos.find(dept => dept.dept === formValues.departmentName);
		if (matchedDept) {
			formValues.department = matchedDept.orgLevel1Code;
		} else {
			formValues.department = "";
		}
	}, [formValues.departmentName]);

	// バリデーションチェック用useEffect
	useEffect(() => {
		const validationMessage = validateUserid(formValues.userId);
		setUsrVali(validationMessage === '');
	}, [formValues.userId, formValues.companyName]);

	useEffect(() => {
		const validationMessage = validateUserNameJp(formValues.userNameJp);
		setNameJpVali(validationMessage === '');
	}, [formValues.userNameJp]);

	useEffect(() => {
		const validationMessage = validateUserNameEng(formValues.userNameEn);
		setNameEnVali(validationMessage === '');
	}, [formValues.userNameEn]);

	useEffect(() => {
		const validationMessage = validateMail(formValues.email);
		setEmailVali(validationMessage === '');
	}, [formValues.email, formValues.userId, formValues.companyName]);

	useEffect(() => {
		const validationMessage = validateComp(formValues.companyName);
		setOrg0Vali(validationMessage === '');
		setFormValues({ ...formValues, department: "", usrroleCode: "" ,departmentName:""});
	}, [formValues.companyName]);

	useEffect(() => {
		const validationMessage = validateDept(formValues.departmentName);
		setOrg1Vali(validationMessage === '');

	}, [formValues.departmentName]);

	useEffect(() => {
		const validationMessage = validateRole(formValues.usrroleCode);
		setRoleVali(validationMessage === '');

	}, [formValues.usrroleCode]);


	if (isLoading) {
		// ロード中の場合はローディング画面
		return (
			<Loading />
		);
	} else {
		return (
			<Container className="addUser" maxWidth="md">

				<Card className="card">
					<CardHeader
						title={t('adduser')}
						className="custom-card-header"
					/>
					<CardContent>
						<Grid container>
							<Box display="flex" className="boxHeader">
								<div className='description'>{t('userAddDescription')}</div>
								<IconButton style={{ color: 'inherit', display: getFuncroleFlg(SYS_ROLE.APP_BAR, OBJ_ROLE.FOLDER_MANAGEMENT_LINK) || getFuncroleFlg(SYS_ROLE.APP_BAR, OBJ_ROLE.USER_MANAGEMENT_LINK) ? "block" : "none" }} component="a" href="/外部ユーザ登録時送信メールサンプル.pdf" target="_blank" rel="noreferrer noopener">
								<AttachEmailIcon />
								</IconButton>
							</Box>							
							<Box display="flex" alignItems="center" width="100%">
								<Typography className="label">{t('userId')}
									<Tooltip title={<span>{t('placeholder.1000000')}<br />{t('placeholder.1000005')}</span>} arrow>
										<svg width="15" height="15" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
											<circle cx="50" cy="50" r="40" fill="black" />
											<text x="50" y="70" fontSize="80" textAnchor="middle" fill="white">?</text>
										</svg>
									</Tooltip>
								</Typography>

								<TextField
									className="textField"
									value={formValues.userId}
									disabled={!flgUserid}
									onChange={(e) => setFormValues({ ...formValues, userId: e.target.value })}
									helperText={validateUserid(formValues.userId)}
									FormHelperTextProps={{ className: 'red-helper-text' }}
									placeholder={t('placeholder.1000010')}
								/>
							</Box>
							<Box display="flex" alignItems="center" width="100%">
								<Typography className="label">{t('userNameJp')}</Typography>
								<TextField
									className="textField"
									value={formValues.userNameJp}
									disabled={!flgUserNameJp}
									helperText={validateUserNameJp(formValues.userNameJp)}
									onChange={(e) => setFormValues({ ...formValues, userNameJp: e.target.value })}
									FormHelperTextProps={{ className: 'red-helper-text' }}
									placeholder={t('placeholder.1000100')}
								/>
							</Box>
							<Box display="flex" alignItems="center" width="100%">
								<Typography className="label">{t('userNameEn')}</Typography>
								<TextField
									className="textField"
									value={formValues.userNameEn}
									disabled={!flgUserNameEn}
									helperText={validateUserNameEng(formValues.userNameEn)}
									onChange={(e) => setFormValues({ ...formValues, userNameEn: e.target.value })}
									FormHelperTextProps={{ className: 'red-helper-text' }}
									placeholder={t('placeholder.1000200')}
								/>
							</Box>

							<Box display="flex" className="boxDrop" alignItems="center" width="100%">
								<Typography className="label">{t('company')}</Typography>
								{/* <FormControl className='dropDownList'>
									<Select
										value={formValues.company}
										onChange={handleOrgLevel0Change}
										disabled={!flgOrgSelector}
										displayEmpty
									>
										<MenuItem value="">
											<em className='placeholder'>{t('placeholder.1000300')}</em>
										</MenuItem>
										{compList.map((compList, index) => (
											<MenuItem key={index} value={compList.orgLevel0Code}>
												{compList.comp}
											</MenuItem>
										))}
									</Select>
									<FormHelperText style={{ color: 'red' }}>
										{validateComp(formValues.company)}
									</FormHelperText>
								</FormControl> */}

								<FormControl className='dropDownList'>
									<Autocomplete
										options={compList.map((comp) => ({
											label: comp.comp,
											value: comp.orgLevel0Code
										}))}
										freeSolo
										renderInput={(params) => <TextField {...params} placeholder={t('placeholder.1000300')} />}
										inputValue={formValues.companyName}
										onInputChange={(event, newValue) => {
											setFormValues({ ...formValues, companyName: newValue });
										}}
										// onChange={(event, newValue) => {
										// 	if (typeof newValue === 'string') {
										// 		setFormValues({ ...formValues, companyName: newValue, orgLevel0Code: '' });
										// 	} else if (newValue && newValue.label && newValue.value) {
										// 		setFormValues({ ...formValues, companyName: newValue.label, orgLevel0Code: newValue.value });
										// 	} else {
										// 		setFormValues({ ...formValues, companyName: '', orgLevel0Code: '' });
										// 	}
										// }}
										disabled={!flgOrgSelector}
									/>
									<FormHelperText style={{ color: 'red' }}>
										{validateComp(formValues.companyName)}
									</FormHelperText>
								</FormControl>
							</Box>

							<Box display="flex" className="boxDrop" alignItems="center" width="100%">
								<Typography className="label">{t('department')}</Typography>
								{/* <FormControl className='dropDownList'>
									<Select
										value={formValues.department}
										onChange={(e) => setFormValues({ ...formValues, department: e.target.value })}
										disabled={!flgOrg1Selector}
										id="department-select"
										displayEmpty
									>
										<MenuItem value="" >
											<em className='placeholder'>{t('placeholder.1000300')}</em>
										</MenuItem>
										{filteredOrgLevel1Infos.map((orgLevel1Info, subIndex) => (
											<MenuItem key={subIndex} value={orgLevel1Info.orgLevel1Code}>
												{orgLevel1Info.dept}
											</MenuItem>
										))}
									</Select>
									<FormHelperText style={{ color: 'red' }}>
										{validateDept(formValues.department)}
									</FormHelperText>
								</FormControl> */}

								<FormControl className='dropDownList'>
									<Autocomplete
										options={filteredOrgLevel1Infos.map((dept) => ({
											label: dept.dept,
											value: dept.orgLevel1Code
										}))}
										freeSolo
										renderInput={(params) => <TextField {...params} placeholder={t('placeholder.1000300')} />}
										inputValue={formValues.departmentName}
										onInputChange={(event, newValue) => {
											setFormValues({ ...formValues, departmentName: newValue });
										}}
										onChange={(event, newValue) => {
											if (typeof newValue === 'string') {
												setFormValues({ ...formValues, departmentName: newValue, orgLevel1Code: '' });
											} else if (newValue && newValue.label && newValue.value) {
												setFormValues({ ...formValues, departmentName: newValue.label, orgLevel1Code: newValue.value });
											} else {
												setFormValues({ ...formValues, departmentName: '', orgLevel1Code: '' });
											}
										}}
										disabled={!flgOrg1Selector}
									/>
									<FormHelperText style={{ color: 'red' }}>
										{validateDept(formValues.departmentName)}
									</FormHelperText>
								</FormControl>
							</Box>

							<Box display="flex" alignItems="center" width="100%">
								<Typography className="label">{t('email')}</Typography>
								<TextField
									className="textField"
									value={formValues.email}
									helperText={validateMail(formValues.email)}
									disabled={!flgMailAddress}
									onChange={(e) => setFormValues({ ...formValues, email: e.target.value })}
									FormHelperTextProps={{ className: 'red-helper-text' }}
									placeholder={t('placeholder.1000400')}
								/>
							</Box>

							<Box display="flex" className="boxDrop" alignItems="center" width="100%">
								<Typography className="label">{t('authority')}
									<Tooltip title={<span>{t('placeholder.1001000')}<br />
										{t('placeholder.1001010')}<br />
										{t('placeholder.1001020')}<br />
										{t('placeholder.1001030')}<br />
										{t('placeholder.1001040')}<br /><br />
										{t('placeholder.1001050')}<br />
										{t('placeholder.1001060')}<br />
										{t('placeholder.1001070')}<br /><br />
										{t('placeholder.1001080')}<br />
										{t('placeholder.1001090')}<br /><br />
										{t('placeholder.1001100')}<br />
										{t('placeholder.1001110')}</span>} arrow>
										<svg width="15" height="15" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
											<circle cx="50" cy="50" r="40" fill="black" />
											<text x="50" y="70" fontSize="80" textAnchor="middle" fill="white">?</text>
										</svg>
									</Tooltip>
								</Typography>
								<FormControl className='dropDownList'>
									<Select
										value={formValues.usrroleCode}
										onChange={(e) => setFormValues({ ...formValues, usrroleCode: e.target.value })}
										id="authority-select"
										displayEmpty
									>
										<MenuItem value="">
											<em className='placeholder'>{t('placeholder.1000300')}</em>
										</MenuItem>
										{filteredUserRoleDescs.map((userRoleList, index) => (
											<MenuItem key={index} value={userRoleList.usrroleCode}>
												{userRoleList.usrroleDesc}
											</MenuItem>
										))}
									</Select>
									<FormHelperText style={{ color: 'red' }}>
										{validateRole(formValues.usrroleCode)}
									</FormHelperText>
								</FormControl>
							</Box>

							<Box display="flex" alignItems="center" width="100%">
								<Typography className="label">{t('dateExpiry')}</Typography>
								<DatePicker
									selected={formValues.expiryDate}
									onChange={(date) => setFormValues({ ...formValues, expiryDate: date })}
									helperText={validateExpiryDate(formValues.expiryDate)}
									defaultValue="2999/12/31"
									dateFormat='yyyy/MM/DD'
									disabled={!flgExpiryDate}
								/>
							</Box>

						</Grid>
						<Grid container justifyContent="flex-end" className='button'>
							<Button
								className="userAddBtn"
								variant="primary"
								onClick={handleAddUserBtnClick}
								disabled={!addUserSaveBtnAuthFlg || !usrVali || !nameJpVali || !nameEnVali || !emailVali || !org0Vali || !org1Vali || !roleVali}
							>
								{t('save')}
							</Button>
							<Button
								className="cancelBtn"
								variant="secondary"
								onClick={handleCancelClick}
							>
								{t('cancel')}
							</Button>
						</Grid>
					</CardContent>
				</Card>
				{(dialogStatus === DIALOG_STATUS.OK_DIALOG || dialogStatus === DIALOG_STATUS.OK_DIALOG_BACK) && (
					<Dialog
						isOpen={dialogOpen}
						content={dialogContent}
						onOk={onOk}
					/>
				)}
				{(dialogStatus === DIALOG_STATUS.DETAIL_DIALOG || dialogStatus === DIALOG_STATUS.DETAIL_DIALOG_BACK) && (
					<DetailDialog
						isOpen={dialogOpen}
						content={dialogContent}
						detailContent={detailContent}
						onOk={onOk}
					/>
				)}
				{dialogStatus === DIALOG_STATUS.ADDUSER_CONFIRM_DIALOG && (
					<ConfirmDialog
						isOpen={confirmDialogOpen}
						content={confirmDialogContent}
						onOk={onAddUserConfirmOK}
						onCancel={onCancel}
					/>
				)}
				{dialogStatus === DIALOG_STATUS.ADDUSER_COMPLETE_DIALOG && (
					<Dialog
						isOpen={dialogOpen}
						content={dialogContent}
						onOk={onOk}
					/>
				)}
			</Container>
		);
	}
}
export default AddUser;
